// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"519":"a1fa7a218e33960a65e0","560":"d0327a6f93b06742add8","615":"fbef72819568e5c42693","916":"4ffad8652ca22fc00d02"}[chunkId] + ".chunk.js";
};